import React from 'react';
import './Features.css';
import featuresImage from '../images/features-image.jpg';

const Features = () => {
    return (
        <section className="features">
            <div className="features-container">
                <div className="features-image">
                    <img src={featuresImage} alt="Features" />
                </div>
                <div className="features-content">
                    <h2>Everything you need in a crypto app, nothing you don't.</h2>
                    <ul>
                        <li>Store your assets with a self-custody wallet.</li>
                        <li>Manage multiple wallets across the top networks.</li>
                        <li>Instantly buy BTC and hundreds of other cryptocurrencies.</li>
                        <li>Exchange thousands of crypto pairs with a tap.</li>
                        <li>Spend crypto, buy gift cards, and pay off bills from your wallet.</li>
                    </ul>
                    <a href="#!" className="get-the-app">Get the App &rarr;</a>
                </div>
            </div>
        </section>
    );
};

export default Features;